<template>

  <div class="About">

   <!--  <video ref="video" autoplay controls loop>
        <source src="../assets/menearth.webm" type="video/webm">
    </video>  -->

    <!-- <a-scene ref="scene" arjs="sourceType: webcam;">    
        <a-entity camera ref="camera" />
    </a-scene>   -->

    <video class="About__video" ref="webcam" width="640" height="480" autoplay="true" id="videoElement"></video>
    <div class="About__txt">{{ txt }}</div>
    <canvas id="canvas" width="640" height="480"></canvas>

    <!-- <div class="About__container"></div> -->

  </div>
</template>

<script>

import 'tracking/build/tracking-min.js'

export default {

    name: 'About',
    data: () => ({
        txt: 'Tracks'
    }),
    beforeDestroy() {
    },
    created() {
    },
    mounted() { 


        // window.plot = function(x, y, w, h) {

        //     // console.log('x');

        //     var rect = document.createElement('div')
        //     document.querySelector('.About__container').appendChild(rect)
        //         rect.classList.add('rect')
        //         rect.style.width = w + 'px'
        //         rect.style.height = h + 'px'
        //         rect.style.left = '0px'
        //         rect.style.top = '0px'
        // }


        var canvas = document.getElementById('canvas')
        var context = canvas.getContext('2d')



        var video = document.querySelector("#videoElement")
        if (navigator.mediaDevices.getUserMedia) {       
                navigator.mediaDevices.getUserMedia({video: true})
            .then((stream)=> {
                video.srcObject = stream;
            })
            .catch((err0r)=> {
                console.log("Something went wrong!");
            });
        }

        tracking.ColorTracker.registerColor('purple', function(r, g, b) {
            var dx = r - 120;
            var dy = g - 60;
            var dz = b - 210;

            if ((b - g) >= 100 && (r - g) >= 60) {
              return true;
            }
            return dx * dx + dy * dy + dz * dz < 3500;
          });



        var colors = new tracking.ColorTracker(['yellow', 'purple']);
            colors.on('track', (event)=> {

                if (event.data.length === 0) {
                  // No colors were detected in this frame.
                } else {

                    event.data.forEach((rect)=> {

                        // console.log('xxxxx');

                        // window.plot(0, 0, rect.height, rect.width, rect.color)

                        console.log(rect.x, rect.y, rect.height, rect.width);
                        // this.txt = rect.color


                        if (rect.color === 'custom') { rect.color = tracker.customColor }



                        context.clearRect(0, 0, canvas.width, canvas.height);

                        event.data.forEach(function(rect) {
                          // if (rect.color === 'custom') {
                          //   rect.color = tracker.customColor;
                          // }

                          rect.x = 0
                          rect.y = 0

                          context.strokeStyle = rect.color;
                          context.strokeRect(rect.x, rect.y, rect.width, rect.height);
                          context.font = '11px Helvetica';
                          context.fillStyle = "#fff";
                          context.fillText('x: ' + rect.x + 'px', rect.x + rect.width + 5, rect.y + 11);
                          context.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 22);
                        });















                    })
                }
            })

        tracking.track(this.$refs.webcam, colors, { camera: true })


        // window.onload = function() {

        //     var img = document.getElementById('img');
        //     var tracker = new tracking.ObjectTracker(['face', 'eye', 'mouth']);
        //         tracker.setStepSize(1.7);

        //         tracking.track('#img', tracker);

        //   tracker.on('track', function(event) {
        //     event.data.forEach(function(rect) {
        //       window.plot(rect.x, rect.y, rect.width, rect.height);
        //     });
        //   });

        // window.plot = function(x, y, w, h) {

        //     var rect = document.createElement('div');
        //     document.querySelector('.demo-container').appendChild(rect);
        //         rect.classList.add('rect');
        //         rect.style.width = w + 'px';
        //         rect.style.height = h + 'px';
        //         rect.style.left = (img.offsetLeft + x) + 'px';
        //         rect.style.top = (img.offsetTop + y) + 'px';
        //   };
        // };
      

        // tracking.track(this.$refs.webcam, colors, { camera: true })

        // window.onload = function() {
        // var canvas = document.getElementById('canvas');
        // var context = canvas.getContext('2d');

        // tracking.ColorTracker.registerColor('purple', (r, g, b)=> {
        //     var dx = r - 120;
        //     var dy = g - 60;
        //     var dz = b - 210;

        //     if ((b - g) >= 100 && (r - g) >= 60) {
        //         return true;
        //     }
        //     return dx * dx + dy * dy + dz * dz < 3500;
        // });

        // var tracker = new tracking.ColorTracker(['yellow', 'purple']);
        //     tracker.setMinDimension(5);
        //     tracking.track('#video', tracker);

        //     tracker.on('track', (event)=> {
        //         context.clearRect(0, 0, canvas.width, canvas.height);

        //         event.data.forEach((rect)=> {
        //             if (rect.color === 'custom') {
        //                 rect.color = tracker.customColor;
        //             }

        //         context.strokeStyle = rect.color;
        //         context.strokeRect(rect.x, rect.y, rect.width, rect.height);
        //         context.font = '11px Helvetica';
        //         context.fillStyle = "#fff";
        //         context.fillText('x: ' + rect.x + 'px', rect.x + rect.width + 5, rect.y + 11);
        //         context.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 22);
        //     });
        // });

    },

}
</script>


<style lang="stylus">

.About
    &__txt
        color red

    &__container
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        width 640px
        height 480px
        border 1px solid yellow

    &__video
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)


canvas
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    width 640px
    height 480px
    border 1px solid red




</style>










































